<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        <div class="columns">
          <div class="column" v-if="isCreate">
            <h2 class="title is-3">Создать аккаунт</h2>
          </div>
          <div class="column" v-else>
            <h2 class="title is-3">Изменить аккаунт: {{ currentAccountName }}</h2>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-layout column>
            <b-field label="Название">
              <b-input v-model="currentFirebase.name"></b-input>
            </b-field>

            <b-field label="Бандл">
              <b-input v-model="currentFirebase.bundle"></b-input>
            </b-field>

            <b-field label="Статус">
              <v-select
                outlined
                dense
                hide-details
                :items="statuses"
                item-value="value"
                item-text="name"
                v-model="currentFirebase.status"
              />
            </b-field>

            <b-field label="Платформа">
              <v-select
                outlined
                dense
                hide-details
                :items="platforms"
                item-value="value"
                item-text="name"
                v-model="currentFirebase.platform"
              />
            </b-field>

            <b-field class="mt-4" label="Размеры поддерживаемых картинок">
              <v-select
              outlined
              dense
              hide-details
              clearable
              :items="sizes"
              item-value="size"
              item-text="size"
              label="Размер"
              v-model="currentFirebase.size_img"
            >
              <template v-slot:item="{ item }">
                {{ item.size }} ({{ item.count }})
              </template>
              <template v-slot:selection="{ item }">
                {{ item.size }} ({{ item.count }})
              </template>
            </v-select>
            </b-field>

            <b-field label="Прокси">
              <b-input v-model="currentFirebase.ip_proxy"></b-input>
            </b-field>

            <p>
              Например http://192.168.255.201:8001
            </p>

            <b-field label="Api Key">
              <b-input v-model="currentFirebase.api_key_proxy"></b-input>
            </b-field>

            <div v-if="isCreate">
              <v-divider/>
              <label class="label">Донор данных</label>

              <v-select
                v-model="currentFirebase.firebase_id_donor"
                outlined
                dense
                hide-details
                clearable
                :items="firebases.results"
                item-value="id"
                item-text="name"
              ></v-select>
            </div>

            <div v-if="currentFirebase.user_access">
              <v-divider/>
              <label class="label">Доступы</label>

              <b-field class="mt-4" label="Все пользователи">
                <b-switch
                  @input="onAllUsersChange"
                  v-model="currentFirebase.user_access.all">
                  {{ currentFirebase.user_access.all ? 'Да' : 'Нет' }}
                </b-switch>
              </b-field>

              <div v-if="!currentFirebase.user_access.all">
                <p class="error--text">Когда выбираете человека в группах пользователей, доступ будет у него и ВСЕЙ ЕГО КОМАНДЫ</p>

                <v-select
                  outlined
                  v-model="currentFirebase.user_access.subordinates_of"
                  label="Группы пользователей"
                  :items="teamleads"
                  item-value="id"
                  item-text="name"
                  multiple
                  class="mt-7"
                ></v-select>

                <v-select
                  class="mb-3"
                  outlined
                  v-model="currentFirebase.user_access.users"
                  label="Пользователи"
                  :items="profiles"
                  item-value="id"
                  item-text="name"
                  multiple
                ></v-select>
              </div>
              <v-divider/>
            </div>

            <p class="error--text" v-if="currentFirebase.has_file">
              Файл уже загружен. Не загружайте новый, если не хотите ничего менять.
            </p>

            <b-field>
              <b-upload
                v-model="currentFirebase.files"
                :multiple="false"
                drag-drop
                class="full-width-upload"
                accept=".json"
                @input="handleFileUpload"
              >
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon
                        icon="upload"
                        size="is-large"
                      />
                    </p>
                    <p v-if="currentFirebase.id == null">Перетащите ваш JSON файл сюда или кликните для загрузки</p>
                    <p v-else>Для изменения JSON файла перетащите его сюда</p>
                  </div>
                </section>
              </b-upload>
            </b-field>

            <div class="tags">
              <span v-for="(file, index) in currentFirebase.files"
                    :key="index"
                    class="tag is-primary">
                {{ file.name }}
                <button class="delete is-small"
                        type="button"
                        @click="deleteDropFile(index)">
                </button>
              </span>
            </div>

            <b-field label="Домен">
              <b-input v-model="currentFirebase.domain"></b-input>
            </b-field>

            <b-field label="CDN">
              <b-input v-model="currentFirebase.cdn"></b-input>
            </b-field>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" v-if="isCreate" @click="createFirebase()">Добавить</v-btn>
        <v-btn text color="primary" v-else @click="updateFirebase()">Обновить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import { toFormData } from '@/app/shared/services/helpers';

export default {
  name: 'FirebaseDetailsModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
      currentAccountName: '',

      statuses: [
        { value: 'published', name: 'Активная' },
        { value: 'moderation', name: 'Модерация' },
        { value: 'blocked', name: 'Заблокировано' },
        { value: 'in_development', name: 'В разработке' },
        { value: 'deleted', name: 'Удалено' },
        { value: 'another', name: 'Другое' },
      ],
      platforms: [
        { value: 'android', name: 'Android' },
        { value: 'ios', name: 'iOS' },
        { value: 'rustore', name: 'Rustore' },
        { value: null, name: 'Другое' },
      ]
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.currentAccountName = this.currentFirebase.name;

        if (!this.currentFirebase.status) {
          this.currentFirebase.status = 'in_development';
        }

        if (!this.currentFirebase.platform) {
          this.currentFirebase.platform = null;
        }

        this.getFirebases();
      }
    },
  },
  created() {
    this.getProfiles();
    this.getTeamLeads();
    this.getFirebases();
    this.getImgSizes();
  },
  computed: {
    isCreate() {
      return this.currentFirebase.id == null;
    },
    firebases() {
      return this.$store.getters.GET_FIREBASES;
    },
    isLoading: {
      get() {
        return this.$store.getters.GET_FIREBASE_DETAILS_MODAL_LOADING;
      },
      set(value) {
        this.$store.commit('SET_FIREBASE_DETAILS_MODAL_LOADING', value);
      }
    },
    isOpen: {
      get() {
        return this.$store.getters.GET_FIREBASE_DETAILS_MODAL_OPENED;
      },
      set() {
        this.$store.commit('SET_FIREBASE_DETAILS_MODAL_OPENED', false);
      },
    },
    currentFirebase: {
      get() {
        return this.$store.getters.GET_CURRENT_FIREBASE;
      },
      set(value) {
        this.$store.commit("SET_CURRENT_FIREBASE", value);
      },
    },
    profiles: {
      get() {
        return this.$store.getters.GET_PROFILES;
      },
      set(value) {
        this.$store.commit("SET_PROFILES", value);
      },
    },
    teamleads() {
      return this.$store.getters.GET_TEAMLEAD_DATA;
    },
    sizes() {
      return this.$store.getters.GET_SIZES_IMG;
    },
  },
  methods: {
    getImgSizes() {
      this.$store.dispatch("GET_IMG_SIZES").catch(() => {
        this.$toast.error("Ошибка загрузки размеров изображений");
      });
    },
    onAllUsersChange() {
      if (this.currentFirebase.user_access.all) {
        this.currentFirebase.user_access.users = [];
        this.currentFirebase.user_access.subordinates_of = [];
      }
    },
    handleFileUpload(file) {
      // Проверяем, что файл является JSON
      if (file && file.type === 'application/json') {
        this.currentFirebase.files = [file];
      } else {
        this.$toast.error("Пожалуйста, выберите только JSON файл.");
      }
    },
    deleteDropFile(index) {
      this.currentFirebase.files.splice(index, 1); // Удаляем файл из массива files
    },
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.currentFirebase = {}; // Очистка текущего Firebase
      this.$store.commit('SET_FIREBASE_DETAILS_MODAL_OPENED', false);
    },
    createFirebase() {
      this.$store.dispatch('CREATE_FIREBASE', this.customToFormData(this.currentFirebase))
        .then(() => {
          this.$toast.success("Аккаунт создан!");
        })
        .catch((error) => {
          this.$toast.error(error);
        }).finally(() => {
          this.close();
      });
    },
    updateFirebase() {
      let data = {
        id: this.currentFirebase.id,
        form: this.customToFormData(this.currentFirebase)
      }
      this.$store.dispatch('UPDATE_FIREBASE', data)
        .then(() => {
          this.$toast.success("Firebase успешно изменен");
          this.close();
        })
        .catch(() => {
          this.$toast.error("Ошибка при изменении Firebase");
        });
    },
    customToFormData(params) {
      const formData = new FormData();

      // Добавляем все ключи, кроме файлов
      Object.keys(params).forEach(key => {
        if (key !== 'files') {
          // Если значение - объект или массив, сериализуем в JSON
          if (typeof params[key] === 'object' && params[key] !== null) {
            formData.append(key, JSON.stringify(params[key]));
          } else {
            formData.append(key, params[key]);
          }
        }
      });

      // Добавляем файлы отдельно, если они есть
      if (params.files && Array.isArray(params.files)) {
        params.files.forEach(file => {
          if (file instanceof File) {
            formData.append('files', file);
          }
        });
      }

      return formData;
    },
    getProfiles() {
      this.isLoading = true;
      const params = {
        filters: {},
        type: 'SET_PROFILES',
      };
      this.$store
        .dispatch("GET_PROFILES", params)
        .then((data) => {
        })
        .catch((error) => {
          this.$toast.error("Неизвестная ошибка!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getTeamLeads() {
      this.isLoading = true;
      const params = {
        filters: { role: 'teamlead', status: 'true' },
        type: 'SET_TEAMLEADS',
      };
      this.$store
        .dispatch("GET_PROFILES", params)
        .then((data) => {})
        .catch((error) => {
          this.$toast.error("Неизвестная ошибка!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getFirebases() {
      this.$store.dispatch("GET_FIREBASES", {page: 'all'}).catch(() => {
        this.$toast.error("Ошибка при получении мостиков");
      });
    },
  },
};
</script>

<style>
.full-width-upload {
  width: 100%;
  display: block;
}

.full-width-upload .section {
  width: 100%;
}

.full-width-upload .content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
